import { render } from "./VitalsPage.vue?vue&type=template&id=ae955e28&scoped=true"
import script from "./VitalsPage.vue?vue&type=script&lang=js"
export * from "./VitalsPage.vue?vue&type=script&lang=js"

import "./VitalsPage.vue?vue&type=style&index=0&id=ae955e28&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae955e28"]])

export default __exports__